<template>
  <div>
    <fade-transition :mode="'out-in'">
      <component :is="template">
        <router-view />
      </component>
    </fade-transition>
    <ConfirmNavigationModal :show-modal="showConfirmNavigationModal" @leave="nextFn" @stay="stayFn" />
  </div>
</template>
<script>
import AppTemplate from '@/components/layouts/templates/AppTemplate'
import ConfirmNavigationModal from '@/components/utils/ConfirmNavigationModal.vue'
import isFunction from 'lodash/isFunction'

import 'shipbob-design-system/dist/bootstrap/sb-bootstrap.css'
import 'shipbob-design-system/dist/system/system.css'
import '../assets/scss/app.scss'

const AppSideNavTemplate = () =>
  import(
    /* webpackChunkName: "AppSideNavTemplate" */ '@/components/layouts/templates/AppSideNavTemplate'
  )
export default {
  name: 'ShipbobVue',
  components: { ConfirmNavigationModal },
  provide () {
    return {
      preventNavigationHandler: this.preventNavigationHandler
    }
  },
  data () {
    return {
      showConfirmNavigationModal: false,
      nextFn: () => {},
      stayFn: () => {}
    }
  },
  computed: {
    template () {
      return this.$shipBobStore.getters.showSideNav
        ? AppSideNavTemplate
        : AppTemplate
    }
  },
  methods: {
    preventNavigationHandler (nextFnOrTo, stayOnSamePageFn) {
      this.showConfirmNavigationModal = true
      this.nextFn = () => {
        isFunction(nextFnOrTo) ? nextFnOrTo() : this.$router.push(nextFnOrTo)
        this.showConfirmNavigationModal = false
      }
      this.stayFn = () => {
        stayOnSamePageFn && stayOnSamePageFn()
        this.showConfirmNavigationModal = false
      }
    }
  }
}
</script>
<style lang="scss">
@import "../node_modules/toastr/toastr.scss";
#appContainer {
  width: 100%;
  height: 100vh;
}
</style>
